// SYSTEM PERMISSION KEYS CONSTANTS

export const PERMISSION_KEYS = {
	DASHBOARD: 'dashboard',
	SETTINGS: 'settings',
	PROFILE: 'profile',
	USER_MANAGEMENT: 'user_management',
	USERS: 'users',
	ROLE: 'role',
	COMPANY: 'company',
	MASTER: 'master',
	ITEM: 'item',
	ITEM_TYPE: 'item_type',
	SIZE: 'size',
	COLOUR: 'colour',
	PROCESS: 'process',
	FABRIC: 'fabric',
	FABRIC_TYPE: 'fabric_type',
	FABRIC_STAGE: 'fabric_stage',
	PARTY: 'party',
	EXPENSE_CATEGORY: 'expense_category',
	TAX_RATE: 'tax_rate',
	CUTTING_COMPONENT: 'cutting_component',
	LABOUR: 'labour',
	LOGIN_HISTORY: 'login_history',

	// PRODUCTION
	PRODUCTION: 'production',
	FABRIC_INWARD: 'fabric_inward',
	FABRIC_STOCK: 'fabric_stock',
	CUTTING_STOCK: 'cutting_stock',
	CUTTING: 'cutting',
	BUNDLING: 'bundling',
	BUNDLE_STOCK: 'bundle_stock',
	PROCESS_ISSUE: 'process_issue',
	PROCESS_RECEIVE: 'process_receive',
	PROCESS_FLOW: 'process_flow',
	READY_STOCK: 'ready_stock',
	LABOUR_HISAAB: 'labour_hisaab',
	LABOUR_HISAAB_PIECE_RATE: 'labour_hisaab_piece_rate',
	LABOUR_HISAAB_MONTHLY_SALARY: 'labour_hisaab_monthly_salary',
	DELIVERY_CHALLAN: 'delivery_challan',

	// SALES
	SALES: 'sales',
	SALES_ORDER: 'sales_order',
	SALES_INVOICE: 'sales_invoice',
	CUSTOMER_PAYMENT: 'customer_payment',
	CREDIT_NOTE: 'credit_note',

	// PURCHASE
	PURCHASE: 'purchase',
	PURCHASE_ORDER: 'purchase_order',
	PURCHASE_INVOICE: 'purchase_invoice',
	SUPPLIER_PAYMENT: 'supplier_payment',
	DEBIT_NOTE: 'debit_note',

	// FINANCE
	FINANCE: 'finance',
	EXPENSES: 'expenses',
	PETTY_CASH: 'petty_cash',
	BANK: 'bank',

	// REPORTS
	REPORTS: 'reports',
	REPORTS_DASHBOARD: 'reports_dashboard',
	REPORT_PRODUCTION_SUMMARY: 'report_production_summary',
	REPORT_FABRIC_STOCK: 'report_fabric_stock',
	REPORT_CUTTING: 'report_cutting',
	REPORT_CUTTING_VARIANCE: 'report_cutting_variance',
	REPORT_CUTTING_STOCK: 'report_cutting_stock',
	REPORT_BUNDLE_TRACKING: 'report_bundle_tracking',
	REPORT_PROCESS_PENDING: 'report_process_pending',
	REPORT_READY_STOCK: 'report_ready_stock',
	REPORT_DISPATCH: 'report_dispatch',
	REPORT_LOT_TRACE: 'report_lot_trace',
	REPORT_LABOUR_PAYMENT: 'report_labour_payment',
	REPORT_LABOUR_PAYMENT_PIECE_RATE: 'report_labour_payment_piece_rate',
	REPORT_LABOUR_PAYMENT_MONTHLY_SALARY: 'report_labour_payment_monthly_salary',
} as const;

export type TPermissionKey = (typeof PERMISSION_KEYS)[keyof typeof PERMISSION_KEYS];

export default PERMISSION_KEYS;
